<template>
  <el-drawer customClass="el-drawer-right" title="校正说明" :visible.sync="drawer">
    <el-form :model="formData" ref="form" :rules="rules">
      <el-form-item label="药品通用名">
        <el-input :disabled="true" v-model="formData.drugName" size="mini"></el-input>
      </el-form-item>
      <el-form-item label="药店名称" v-if="formData.storeName">
        <el-input :disabled="true" v-model="formData.storeName" size="mini"></el-input>
      </el-form-item>
      <el-form-item label="销售时间">
        <el-input :disabled="true" :value="formData.orderTime | formatTime" size="mini"></el-input>
      </el-form-item>
      <el-form-item label="销售订单号">
        <el-input :disabled="true" v-model="formData.orderId" size="mini"></el-input>
      </el-form-item>
      <el-form-item label="校正类型" prop="correctionTypeCode">
        <el-select v-model="formData.correctionTypeCode" style="width: 100%" size="mini">
          <el-option
            v-for="(label, item) in correctionTypeCodeMap"
            :key="item"
            :label="label"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="校正说明" prop="correctionRemark">
        <el-input v-model="formData.correctionRemark" type="textarea" :maxlength="30" size="mini"></el-input>
      </el-form-item>

      <el-form-item label="上传图片" prop="correctionFileIdList">
        <div style="width: 400px; height: 44px"></div>
        <div style="width: 100%">
          <el-upload
            :limit="5"
            ref="upload"
            accept="png,jpg,jpeg"
            action=""
            list-type="picture-card"
            :on-error="handleError"
            :http-request="e => uploadFile(e)"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :on-exceed="handleExceed"
          >
            <i class="el-icon-plus"></i>
            <div slot="tip" class="el-upload__tip">每条数据只能校正一次，请上传相关凭证图片，最多五张</div>
          </el-upload>
        </div>
      </el-form-item>
    </el-form>
    <div class="footer">
      <el-button type="primary" plain size="small" @click="drawer = false">取消</el-button>
      <el-button type="primary" size="small" @click="handleSubmit">提交</el-button>
    </div>
    <el-dialog :visible.sync="dialogVisible" title="" append-to-body>
      <div style="text-align: center">
        <img style="max-width: 100%" :src="dialogImageUrl" alt="" />
      </div>
    </el-dialog>
  </el-drawer>
</template>

<script>
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';
export default {
  props: {
    correctionTypeCodeMap: {
      type: Object,
      default: () => ({})
    },
    type: {
      type: String,
      default: 'Prescription'
    }
  },
  filters: {
    formatTime(val) {
      if (!val) return '--';
      return dayjs(val).format('YYYY-MM-DD HH:mm:ss');
    }
  },
  computed: {
    ...mapGetters(['storeList']),
    storeId() {
      // 多店业务上暂时不考虑
      const { storeList } = this;
      return Array.isArray(storeList) ? storeList?.[0].id : storeList?.id;
    }
  },
  data() {
    var checkFileIdList = (rule, value, callback) => {
      if (!value || !value.length) {
        callback(new Error('请上传图片'));
      } else {
        callback();
      }
    };
    return {
      drawer: false,
      formData: {},
      rules: {
        correctionTypeCode: { required: true, message: '请选择校正类型', trigger: ['blur', 'change'] },
        correctionRemark: { required: true, message: '请输入校正说明', trigger: ['blur', 'change'] },
        correctionFileIdList: { required: true, validator: checkFileIdList, trigger: ['blur', 'change'] }
      },
      dialogImageUrl: '',
      dialogVisible: false,
      title: ''
    };
  },
  methods: {
    async uploadFile(e) {
      const file = e.file;
      const fd = new FormData();
      fd.append(
        'uploadParam',
        JSON.stringify({
          appName: 'amikacin-pic',
          scene: 'prescription_file',
          bizFileName: `amikacin-prescription/${e.file.name}`,
          fileName: `amikacin-prescription/${e.file.name}`
        })
      );
      fd.append('fileStream', file);
      const {
        data: { resId }
      } = await Fetch.uploadImage(fd);
      console.log(e);
      this.formData.correctionFileIdList.push({ resId, uid: e.file.uid });
    },
    init(data) {
      if (this.$refs.upload) this.$refs.upload.clearFiles();
      this.drawer = true;
      this.formData = { ...data, correctionFileIdList: [] };
      if (this.$refs.form) this.$refs.form.resetFields();
    },
    cancelCallBack() {
      this.drawer = false;
    },
    handleRemove(file, fileList) {
      const idx = this.formData.correctionFileIdList.findIndex(e => e.uid === file.uid);
      if (idx > -1) this.formData.correctionFileIdList.splice(idx, 1);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.title = file.name;
      this.dialogVisible = true;
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制上传5张`);
    },
    handleError() {
      this.$message.error(`请按要求上传图片`);
    },
    handleSubmit() {
      const { correctionFileIdList, ...ret } = this.formData;
      const list = correctionFileIdList.map(item => item.resId);
      this.$refs.form.validate(valid => {
        if (valid) {
          Fetch[`submitCorrection${this.type}`]({ correctionFileIdList: list, ...ret }).then(res => {
            this.drawer = false;
            if (this.$refs.upload) this.$refs.upload.clearFiles();
            this.$emit('reload');
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/.el-drawer-right {
  width: 500px !important;
  .el-drawer__header {
    border-bottom: 1px solid rgba(0, 0, 0, 0.05) !important;
    padding: 16px 24px;
    margin-bottom: 0;
    span {
      font-size: 16px !important;
      color: #262626;
    }
  }
  .el-drawer__body {
    padding: 24px 24px 100px;
    overflow-y: auto;
  }
  .el-form-item {
    margin-bottom: 12px;
  }
  .el-form-item__content {
    line-height: 24px;
  }
  .el-upload--picture-card {
    width: 64px;
    height: 64px;
    line-height: 72px;
  }
  .el-upload-list__item {
    width: 64px;
    height: 64px;
    line-height: 64px;
  }

  .el-upload-list__item-actions {
    width: 64px;
    height: 64px;
    line-height: 64px;
  }
  .footer {
    position: fixed;
    right: 0;
    bottom: 0;
    width: 100px;
    width: 420px;
    padding: 12px;
    text-align: right;
    border-top: 1px solid rgba(0, 0, 0, 0.05);
  }
}
</style>
